import { render, staticRenderFns } from "./LeaveCredits.vue?vue&type=template&id=f17a9876&"
import script from "./LeaveCredits.vue?vue&type=script&lang=js&"
export * from "./LeaveCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports